import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { languages } from '../../services/languages';
import { changeLanguage } from '../../actions/language';

import './Lang.scss';

class Lang extends Component {
  changeLang = ({ target }) => {
    const { dispatch } = this.props;
    const lang = target.dataset.lang;

    window.langs.setLanguage(lang);   
    dispatch(changeLanguage(lang));
  }

  get languages() {
    const { currentLang } = this.props;

    return languages.map((lang, index) => {
      const classes = classNames('lang__item', {
        'lang__item_active': lang === currentLang
      });

      return (
        <div key={`lang-${index}`} className={ classes } data-lang={ lang } onClick={ this.changeLang }> { lang } </div>
      )
    })
  }

  render() {
    return (
      <div className="lang">
        {
          this.languages
        }
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { language } = state;
  return {
    currentLang: language.current
  }
}

export default connect(mapStateToProps)(Lang);


// WEBPACK FOOTER //
// ./src/components/Lang/Lang.js